'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fetchElements = exports.fetchElement = undefined;

var _lodash = require('lodash');

var _resources = require('../utils/services/http/resources');

var _resources2 = _interopRequireDefault(_resources);

var _resourceUtil = require('../utils/services/http/resources/resourceUtil');

var _elementActions = require('./elementActions');

var _elementSelector = require('./elementSelector');

var _resourceConstants = require('../utils/services/http/resources/resourceConstants');

var _immutableHelper = require('../../common/utils/immutableHelper');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } // Lib


// Util


// Actions


// State selectors


// Constants


var elementsResource = (0, _resources2.default)(_resourceConstants.RESOURCE_TYPES.elements);

/**
 * Fetches element from the server
 *
 * @param boardId {String} The boardId of the board to fetch from the server.
 * @param force {Boolean} (Optional) If true this will
 *
 * @return {Promise} A promise resolved when the data has been retrieved.
 */
var fetchElement = exports.fetchElement = function fetchElement(elementId, force) {
    return function (dispatch, getState) {
        var state = getState();
        var elementResourcesState = (0, _elementSelector.elementsResourcesSelector)(state);
        var resourceState = elementResourcesState.get(elementId);

        // If we shouldn't fetch the element then resolve immediately
        if (!(0, _resourceUtil.shouldFetchResource)(force, resourceState)) return Promise.resolve();

        return elementsResource({ dispatch: dispatch, id: elementId }).then(function (response) {
            if (response.data.error) return response;

            var remoteElement = response.data;

            var elements = _defineProperty({}, remoteElement.id, remoteElement);

            dispatch((0, _elementActions.loadElements)(elements));
            return response;
        });
    };
};

var fetchElements = exports.fetchElements = function fetchElements(args) {
    return function (dispatch, getState) {
        var elementIds = args.elementIds,
            force = args.force,
            loadAncestors = args.loadAncestors;


        var state = getState();
        var elementResourcesState = (0, _elementSelector.elementsResourcesSelector)(state);

        var getElementResource = (0, _immutableHelper.propFrom)(elementResourcesState);

        // If we are not forcing the fetch, and we have the element, and it has been fetched or it is fetching
        // then we don't need to fetch it again
        var elementIdsToFetch = force ? elementIds : elementIds.filter(function (id) {
            return (0, _resourceUtil.shouldFetchResource)(force, getElementResource(id));
        });

        if (!elementIdsToFetch.length) {
            return Promise.resolve();
        }

        var httpConf = {
            timeout: 10000,
            params: {
                loadAncestors: loadAncestors
            }
        };

        return elementsResource({ dispatch: dispatch, config: httpConf, ids: elementIdsToFetch }).then(function (response) {
            if (!(0, _lodash.size)(response.data.elements)) return response;

            dispatch((0, _elementActions.loadElements)(response.data.elements));
            return response;
        });
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/client/element/elementService.js
// module id = 731
// module chunks = 0